import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=04677dc1&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=04677dc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04677dc1",
  null
  
)

export default component.exports